import TenantUsageStatsContainer from 'components/feature/statistics/tenant/TenantUsageStatsContainer';

const TenantUsageStatsPage = () => {
  return <TenantUsageStatsContainer />;
};
export default TenantUsageStatsPage;
